import { BaseApiClient } from '../BaseApiClient'

export default class VisitorClient extends BaseApiClient {
  static async getList(params) {
    return this.get('visitor/list', {
      params,
      headers: this.getAuthHeaders()
    })
  }

  static async getPassports(params) {
    return this.get('visitor/passports', {
      params,
      headers: this.getAuthHeaders()
    })
  }

  static async getApplications(params) {
    return this.get('visitor/applications', {
      params,
      headers: this.getAuthHeaders()
    })
  }

  static async getApplication(params) {
    return this.get('visitor/application', {
      params,
      headers: this.getAuthHeaders()
    })
  }

  static async extraData() {
    return await this.get('visitor/extra-data', {
      headers: this.getAuthHeaders()
    }).then(response => response.data)
  }
}
